//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { ConfigurableService, ResponsePackageActivation } from "../../../types/common";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";
import Activation from "./Activation";

//-------------------------------------------------------------------------------------------------- Interface
interface ActivationsCardProps {
    id: number,
    selection: number | undefined;
    activation: ResponsePackageActivation;
    onClick: Function;
    dataConf: {
        dataList: ConfigurableService[];
    };
};

//-------------------------------------------------------------------------------------------------- Component
const ActivationsCard = (props: ActivationsCardProps) => {
    const { id, selection, activation, onClick, dataConf } = props;

    return (
        <Card
            key={id}
            style={styles.card}
            bodyStyle={{ padding: "0" }}
            onClick={() => undefined}
        >
            <Row gutter={[12, 12]}
                align={"middle"}
                justify={"space-around"}
                onClick={() => onClick && onClick()}
                style={styles.mainContainer}
            >
                <Col xs={24} md={10}>
                    <div style={styles.imageContainer}>
                        <img
                            style={styles.image}
                            src={activation.logoImgUrl}
                            alt="Imágen de la promoción"
                        />
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <MarkdownPreviewer
                        h1Style={{
                            fontSize: 15,
                            color: "#000000",
                            fontWeight: 500
                        }}
                        h2Style={{
                            fontSize: 12,
                            color: "#707070",
                            fontWeight: 500
                        }}
                        h3Style={{
                            fontSize: 12,
                            color: "#000000",
                            margin: 0,
                            padding: 0,
                            fontWeight: 500
                        }}
                        h4Style={{
                            fontSize: 12,
                            color: "#000000",
                            margin: 0,
                            padding: 0,
                            fontWeight: 500
                        }}
                        textStyle={{
                            fontSize: 10,
                            color: "#000000",
                            margin: 0,
                            padding: 0,
                        }}
                        linkStyle={{
                            fontSize: 12,
                            color: "#000000",
                            textDecoration: "underline",
                        }}
                        mdSource={activation.messageText ? activation.messageText : ""}
                    />
                </Col>
                <Col xs={2}>
                    {
                        id === selection ?
                            <UpOutlined style={styles.iconStyles} />
                            :
                            <DownOutlined style={styles.iconStyles} />
                    }
                </Col>
            </Row>
            {
                id === selection &&
                <Activation activation={activation} dataConf={dataConf} />
            }
        </Card>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    card: {
        margin: 10,
        display: "flex",
        flexDirection: "column",
        borderRadius: 25,
        boxShadow: "0px 0px 8px #00000029",
    },
    mainContainer: {
        padding: "0px 10px 0px 10px",
        cursor: "pointer",
    },
    imageContainer: {
        display: "flex",
        height: 75,
    },
    textContainer: {
        flex: 1,
        display: "flex",
    },
    image: {
        width: 120,
        objectFit: "contain",
    },
    iconContainer: {
        display: "flex",
    },
    iconStyles: {
        fontSize: 12,
        color: "#757982",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ActivationsCard;
